<template>
  <div>
    myCollection我的收藏
  </div>
</template>

<script>
export default {
  name: "myCollection",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>